import axios from "axios";
import React, { useEffect, useState } from "react";
import AlertDialog from "../../AlertDialog";
import { baseUrl, mainBaseUrl } from "../../App";
import "./component.scss";
const TemplateComponent = ({ data }) => {
  const title = "Delete Template";
  const description = " Do you really want to delete Template ?";
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [base64Image, setBase64Image] = useState("");

  const handleClose = () => {
    setOpen(false);
  };
  const onAgree = () => {
    setLoading(true);
    var config = {
      method: "delete",
      url: `${mainBaseUrl}/certificate/template/${data.id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-Key": baseUrl,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        setOpen(false);
        alert("Template Deleted Successfully");
        window.location.reload();
      })
      .catch(function (error) {
        setLoading(false);
        setOpen(false);
        alert(error.response.data.error);
      });
  };

  const getImageBase64 = () => {
    axios
      .get(
        `${mainBaseUrl}/certificate/templateImage/${data.certificateTemplateImage.id}`
      )
      .then((response) =>
        setBase64Image(
          Buffer.from(response.data.image.data, "binary").toString("base64")
        )
      );
  };

  useEffect(() => {
    getImageBase64();
  }, []);

  return (
    <div className="mainTempComponent">
      <AlertDialog
        title={title}
        description={description}
        isLoading={loading}
        open={open}
        handleClose={handleClose}
        onAgree={onAgree}
      />
      <div className="imageContainer">
        <img
          style={{
            height: "100%",
            width: "100%",
            objectFit: "contain",
            borderRadius: "20px 20px 0px 0px",
          }}
          src={`data:image/png;base64,${base64Image}`}
          alt="certificate image"
        />
      </div>

      <div className="templateInfo">
        <h3>{data.templateName}</h3>
        <p>{new Date(data.createdAt).toLocaleDateString()}</p>
      </div>
      <div onClick={() => setOpen(true)} className="deleteButton">
        <h4>Delete</h4>
      </div>
    </div>
  );
};

export default TemplateComponent;
